const oneDay = 24 * 60 * 60 * 1000;

export const calculateDateDifference = (startDate, endDate) => {
    let endDateBaseline = new Date(endDate.toISOString().substr(0,10));
    let startDateBaseline = new Date(startDate.toISOString().substr(0,10));
    return Math.floor((endDateBaseline.getTime() - startDateBaseline.getTime()) / oneDay)
}